import { dashboardTime } from "../arrayUtils";

export const CONTAINER_SIZE = {
    EXTRA_SMALL: "extra_small",
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
    EXTRA_LARGE: "extra_large",
    CUSTOM:"custom"
    // JUMBO: "jumbo"
};

export const LAYOUT_TYPE = {
    SUMMARY_VIEW:"summary_view",
    GRAPH:"graph_view",
    LIST_VIEW:"list_view",
    DROPDOWN_VIEW:"dropdown_view"
}
    
export const WIDGET_NAME = {
    //extraSmall
    CUSTOMER_DETAILS_WIDGET:"customer_details_widget",
    CUSTOMER_PRIMARY_CONTACT_DETAILS_WIDGET:"customer_primary_contact_details_widget",
    ACCOUNT_MANAGERS_LIST_WIDGET:"account_managers_list_widget",
    CUSTOMER_APPROVER_DETAILS_WIDGET:"customer_approver_details_widget",
    //small
    WORLDWIDE_POPS_COUNT_WIDGET:"worldwide_pops_count_widget",
    LIVE_SERVICES_COUNT_WIDGET:"live_services_count_widget",
    USERS_INACTIVITY_COUNT_WIDGET:"users_inactivity_count_widget",
    ONBOARDED_CUSTOMERS_COUNT_WIDGET:"onboarded_customers_count_widget",
    //medium
    QUICK_LINKS_WIDGET:"quick_links_widget",
    CUSTOMER_ACCOUNT_MANAGERS_WIDGET:"customer_account_managers_widget",
    SCHEDULED_BROADCAST_MESSAGE_WIDGET:"scheduled_broadcast_message_widget",
    //large
    INCIDENT_MANAGEMENT_STATUS_COUNT_WIDGET:"incident_management_status_count_widget",
    DEMANDS_STATUS_COUNT_WIDGET:"demands_status_count_widget",
    PENDING_ACTION_NOTIFICATION_WIDGET:"pending_action_notification_widget",
    STATUS_WISE_CUSTOMER_USERS_COUNT_WIDGET:"status_wise_customer_users_count_widget",
    CUSTOMER_ONBOARDING_REQUESTS_WIDGET:"customer_onboarding_requests_widget",
    //extraLarge
    STATUS_WISE_INTERNAL_USERS_COUNT_WIDGET:"status_wise_internal_users_count_widget"
}

export const roleLayoutOrderMap = {
    account_manager_internal: ['small', 'extralarge', 'large', 'medium'],
    super_admin_internal: ['small', 'large', 'medium', 'extralarge'],
    commercial_manager_internal: ['small', 'large', 'extralarge', 'medium'],
    head_of_commercial_internal: ['small', 'large', 'extralarge', 'medium'],
    head_of_sales_internal: ['small', 'large', 'extralarge', 'medium'],
    default: ['small', 'large', 'medium', 'extralarge'],
  };

export const getDynamicLayoutOrder = (renderLayout) => {
    const layoutOrder = Object.keys(renderLayout)
      .filter(key => Array.isArray(renderLayout[key]) || renderLayout[key]?.data)  
    return layoutOrder;
};

export const areAdjacent=(arr, large, medium)=>{
    return arr.some((val, i) =>
      (val === large && arr[i + 1] === medium) ||
      (val === medium && arr[i + 1] === large)
    );
}
  

export const MY_TICKETS = [
    { value: "incident", label: "Incidents" },
    { value: "service_request", label: "Service Requests" }
]

export const TAB = {
    INCIDENT: "incident",
    SERVICE_REQUEST: "service_request",
    DEMANDS:"Demands"
}

export const D2C_SERVICES = [
    { value: "OTHERS", label: "IPX Services" },
    { value: "VOLTE", label: "Destination Opening" },
]

export const DEMANDS_SERVICES = [
    { value: "all", label: "All" },
    { value: "diameter", label: "DIAMETER" },
    { value: "dns", label: "DNS" },
    { value: "sigtran", label: "SIGTRAN" },
    { value: "transport", label: "TRANSPORT" },
    { value: "volte", label: "VoLTE" }
]

export const HEADER = {
  INTERNAL: {
      TICKETS: "Tickets",
      DEMANDS: "Demands",
      ORG_LEGAL_NAME: "Organisation Legal Names"
  },
  CUSTOMER: {
      TICKETS: "My Tickets",
      DEMANDS: "My Demands",
  }
};


export const shouldStackMedium = (widgetName,stackedMediums) => {
    return stackedMediums.some(w => w.widgetName === widgetName);
};
export const shouldBeFullWidthSmall = (index, totalCount) => {
    return totalCount % 3 === 1 && index === totalCount - 1;
};
  export const MY_CUSTOMER = [
    { value: "bics", label: "BICS" },
    { value: "voda_fone", label: "Vodafone" },
    { value: "telstra", label: "Telstra" }
  ]

  export const ACTIONS_NAMES = {
    ADD_IVC_SERVICE_NAME: {
      VALUE: 'ADD_IVC_SERVICE_NAME',
      LABEL: (item) => (
        <>IVC Service Name missing for <span>'{item?.actionId}'</span>.</>
      ),
    },
    ADD_FINCA_CODE: {
      VALUE: 'ADD_FINCA_CODE',
      LABEL: (item) => (
        <>Invoice Code missing for <span>'{item?.actionId}'</span>.</>
      ),
    },
    PROVIDE_MORE_INFORMATION: {
      VALUE: 'PROVIDE_MORE_INFORMATION',
      LABEL: (item) => (
        <>Your onboarding request <span>'{item?.actionId}'</span> for <span>'{item?.displayName}'</span> is pending your action.</>
      ),
    },
    ONBOARDING_REQUEST_APPROVAL: {
      VALUE: 'ONBOARDING_REQUEST_APPROVAL',
      LABEL: (item) => (
        <><span>'{item?.displayName}'</span> onboarding request is pending for your approval.</>
      ),
    },
    INC_TICKET_RESOLUTION: {
      VALUE: 'INC_TICKET_RESOLUTION',
      LABEL: (item) => (
        <>Ticket {item?.oneITSMId?<span>'{item?.oneITSMId}'</span>:"---"} requires your attention.</>
      ),
    },
    SR_TICKET_RESOLUTION: {
      VALUE: 'SR_TICKET_RESOLUTION',
      LABEL: (item) => (
        <>Ticket {item?.oneITSMId?<span>'{item?.oneITSMId}'</span>:"---"} requires your attention.</>
      ),
    },
    CUSTOMER_DEMAND_ACTION_PENDING: {
      VALUE: 'CUSTOMER_DEMAND_ACTION_PENDING',
      LABEL: (item) => (
        <>Your Demand <span>'{item?.actionId}'</span> is pending for your action.</>
      ),
    },
    ACCOUNT_MANAGER_DEMAND_ACTION_PENDING: {
      VALUE: 'ACCOUNT_MANAGER_DEMAND_ACTION_PENDING',
      LABEL: (item) => (
        <>Demand <span>'{item?.actionId}'</span> for <span>'{item?.displayName}'</span> is pending for your action. </>
      ),
    },
    ACCOUNT_MANAGER_NEW_DEMAND_RAISED: {
      VALUE: 'ACCOUNT_MANAGER_NEW_DEMAND_RAISED',
      LABEL: (item) => (
        <>New Demand <span>'{item?.actionId}'</span> raised for <span>'{item?.displayName}'</span>. </>
      ),
    },
     D2C_DEMAND_REVIEWER: {
      VALUE: 'D2C_DEMAND_REVIEWER',
      LABEL: (item) => (
        <>New Demand <span>'{item?.actionId}'</span> from <span>'{item?.displayName}'</span> has been raised. Please review it and take appropriate action. </>
      ),
    },
     D2C_CREATE_FEASIBILTY_REPORT: {
      VALUE: 'D2C_CREATE_FEASIBILTY_REPORT',
      LABEL: (item) => (
        <><span>Feasibility Assessment Initiated:</span> Complete the assessment for demand <span>'{item?.actionId}'</span> for <span>'{item?.displayName}'</span>. </>
      ),
    },
     D2C_FEASIBILTY_COMPLETED: {
      VALUE: 'D2C_FEASIBILTY_COMPLETED',
      LABEL: (item) => (
        <><span>Feasibility Assessment completed:</span> Initiate Floor Pricing Preparation for demand <span>'{item?.actionId}'</span> for <span>'{item?.displayName}'</span>. </>
      ),
    },
     D2C_CREATE_QUOTATION_FLOOR_PRICING: {
      VALUE: 'D2C_CREATE_QUOTATION_FLOOR_PRICING',
      LABEL: (item) => (
        <><span>Feasibility Assessment completed:</span> Initiate Floor Pricing Preparation for demand <span>'{item?.actionId}'</span> for <span>'{item?.displayName}'</span>. </>
      ),
    },
     D2C_CREATE_QUOTATION_MARGIN: {
      VALUE: 'D2C_CREATE_QUOTATION_MARGIN',
      LABEL: (item) => (
        <><span>Floor Pricing preparation completed:</span> Initiate Quotation Preparation for demand <span>'{item?.actionId}'</span> for <span>'{item?.displayName}'</span>. </>
      ),
    },
     D2C_QUOTATION_APPROVAL: {
      VALUE: 'D2C_QUOTATION_APPROVAL',
      LABEL: (item) => (
        <>Review and approve the Quotation for demand <span>'{item?.actionId}'</span>. </>
      ),
    },
     D2C_CREATE_ORDER_FORM: {
      VALUE: 'D2C_CREATE_ORDER_FORM',
      LABEL: (item) => (
        <><span>Quotation Approved:</span> Initiate Order Form creation for demand <span>'{item?.actionId}'</span> for <span>'{item?.displayName}'</span>.</>
      ),
    },
     D2C_ORDER_FORM_APPROVAL: {
      VALUE: 'D2C_ORDER_FORM_APPROVAL',
      LABEL: (item) => (
        <>Review and approve the Order Form for demand <span>'{item?.actionId}'</span>.</>
      ),
    },
     D2C_TRIGGER_LEGAL_CONTRACT_EMAIL: {
      VALUE: 'D2C_TRIGGER_LEGAL_CONTRACT_EMAIL',
      LABEL: (item) => (
        <>Share the customer‑signed <span>'{item?.displayName}'</span> Order Form for Demand <span>'{item?.actionId}'</span> with the VGEL team.</>
      ),
    },
     D2C_UPLOAD_LEGAL_CONTRACT: {
      VALUE: 'D2C_UPLOAD_LEGAL_CONTRACT',
      LABEL: (item) => (
        <>Upload duly signed Order Form for <span>'{item?.displayName}'</span> and demand <span>'{item?.actionId}'</span>.</>
      ),
    },
     D2C_INITIATE_PROVISIONING: {
      VALUE: 'D2C_INITIATE_PROVISIONING',
      LABEL: (item) => (
        <>Initiate Service Build provisioning for demand <span>'{item?.actionId}'</span> and <span>'{item?.displayName}'</span>. </>
      ),
    },
     D2C_CREATE_PROVISIONING_REPORT: {
      VALUE: 'D2C_CREATE_PROVISIONING_REPORT',
      LABEL: (item) => (
        <>Upload the <span>'Ready for Service(RFS)'</span> document for demand <span>'{item?.actionId}'</span> and <span>'{item?.displayName}'</span>.</>
      ),
    },
     D2C_CREATE_BILLING_ONBOARDING: {
      VALUE: 'D2C_CREATE_BILLING_ONBOARDING',
      LABEL: (item) => (
        <>Initiate billing(FinCA) onboarding for demand <span>'{item?.actionId}'</span> and <span>'{item?.displayName}'</span>.</>
      ),
    },
    D2C_BILLING_ONBOARDING_APPROVAL: {
      VALUE: 'D2C_BILLING_ONBOARDING_APPROVAL',
      LABEL: (item) => (
        <><span>'{item?.actionId}'</span> is now live. Kindly update the status to Complete.</>
      ),  
    },
     D2C_CUSTOMER_ADDITIONAL_INFO_REQUIRED: {
      VALUE: 'D2C_CUSTOMER_ADDITIONAL_INFO_REQUIRED',
      LABEL: (item) => (
        <>Additional information is required for demand <span>'{item?.actionId}'</span>.Review and submit the requested information.</>
      ),
    },
  };
  
  export const getActionLabel = (value, item) => {
    const action = Object.values(ACTIONS_NAMES).find(
      (a) => a.VALUE === value
    );
    return typeof action?.LABEL === 'function' ? action.LABEL(item) : value;
  };
  
  
  
  
export const actionRouteMap = {
  ADD_IVC_SERVICE_NAME: "/user-management/customerdetail",
  ADD_FINCA_CODE: "/user-management/customerdetail",
  PROVIDE_MORE_INFORMATION: "/user-management/OnboardingDetail",
  ONBOARDING_REQUEST_APPROVAL: "/user-management/OnboardingDetail",
  INC_TICKET_RESOLUTION: "/incident-management/incidentDetail",
  SR_TICKET_RESOLUTION: "/incident-management/serviceRequestDetail",
  CUSTOMER_DEMAND_ACTION_PENDING:"/connectivity/demandDetail",
  ACCOUNT_MANAGER_DEMAND_ACTION_PENDING:"/connectivity/demandDetail",
  ACCOUNT_MANAGER_NEW_DEMAND_RAISED:"/connectivity/demandDetail",
  D2C_DEMAND_REVIEWER:"/connectivity/demandToCashDetail",
  D2C_CREATE_FEASIBILTY_REPORT:"/connectivity/demandToCashDetail",
  D2C_FEASIBILTY_COMPLETED:"/connectivity/demandToCashDetail",
  D2C_CREATE_QUOTATION_FLOOR_PRICING:"/connectivity/demandToCashDetail",
  D2C_CREATE_QUOTATION_MARGIN:"/connectivity/demandToCashDetail",
  D2C_QUOTATION_APPROVAL:"/connectivity/demandToCashDetail",
  D2C_CREATE_ORDER_FORM:"/connectivity/demandToCashDetail",
  D2C_ORDER_FORM_APPROVAL:"/connectivity/demandToCashDetail",
  D2C_TRIGGER_LEGAL_CONTRACT_EMAIL:"/connectivity/demandToCashDetail",
  D2C_UPLOAD_LEGAL_CONTRACT:"/connectivity/demandToCashDetail",
  D2C_INITIATE_PROVISIONING:"/connectivity/demandToCashDetail",
  D2C_CREATE_PROVISIONING_REPORT:"/connectivity/demandToCashDetail",
  D2C_CREATE_BILLING_ONBOARDING:"/connectivity/demandToCashDetail",
  D2C_BILLING_ONBOARDING_APPROVAL:"/connectivity/demandToCashDetail",
  D2C_CUSTOMER_ADDITIONAL_INFO_REQUIRED:"/connectivity/demandToCashDetail",
};

export const GraphLabel = {
  status_wise_customer_users_count_widget: "Users",
  incident_management_status_count_widget: "Tickets",
  demands_status_count_widget: "Demands"
};

  
